module.exports = __webpack_public_path__ + "img/time-circle.18a2fa80.svg";